import * as React from 'react';

const FederatedLoginMicrosoftIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.53348 1.04346H11.9683V11.4782H1.53348V1.04346Z"
      fill="#F35325"
    />
    <path
      d="M13.0117 1.04346H23.4465V11.4782H13.0117V1.04346Z"
      fill="#81BC06"
    />
    <path d="M1.53348 12.522H11.9683V22.9568H1.53348V12.522Z" fill="#05A6F0" />
    <path d="M13.0117 12.522H23.4465V22.9568H13.0117V12.522Z" fill="#FFBA08" />
  </svg>
);

export default FederatedLoginMicrosoftIcon;
